<template>
    <div class="manage--left" ref="lesson-left">
        <!-- Check: Hiển thị tất cả khóa học. Bao gồm đã hoàn thành -->
        <div class="lessons-done nqt__switch" v-if="!mobile">
            <p>{{ $t("new.showCompletedCourse") }}</p>
            <span class="menu-switch-school" :value="courseCompleted" :class="{ 'menu-switch-school-on': courseCompleted }" @click="switchCourses({courseCompleted: !courseCompleted, language: $lang()})"></span>
        </div>

        <!-- Khóa học mới nhất -->
        <div class="lkt_titleCatalog border-bt lkt_hover" :class="{isActive: activeItem.type == 1}" @click="changeItem({type : 1, name: $t('new.title130')})">{{$t('new.title130')}}</div>

        <!-- Khóa học lựa chọn -->
        <div class="lkt_titleCatalog border-bt lkt_hover" :class="{isActive: activeItem.type == 99}" @click="changeItem({type : 99, name: $t('new.title211')})">{{$t('new.title211')}}</div>
        
        <!-- Khóa học Hot -->
        <div class="lkt_titleCatalog border-bt lkt_hover" :class="{isActive: activeItem.type == 2}" @click="changeItem({type : 2, name: $t('new.title186')})">{{$t('new.title186')}}</div>

        <!-- Success course -->
        <div class="lkt_titleCatalog border-bt lkt_hover" :class="{isActive: activeItem.type == 5}" @click="changeItem({type : 5, name: $t('new.title222')})">{{$t('new.title222')}}</div>
        
        <!-- Danh mục khóa học -->
        <div class="border-bt" >
            <div class="lkt_titleCatalog">
                <p>{{$t('new.title189')}}</p>
                <div class="setCourse">
                    <img @click="setCourse('/home/setSelfMenu')" src="/static/images/settings.png" alt="settings" />
                </div>
            </div>
            <div class="listCatalog">
                <ul>
                    <li class="SchoolBusiness_menu_li lkt_hover" v-for="item in menuOne" :key="item.id" :class="{isActive: activeItem.type == 3 && activeItem.tagID == item.id}" @click="changeItem({type : 3, tagID: item.id, language: $lang(), name: item.name})">
                        <p>&#9830; &nbsp;{{ item.name }}</p>
                    </li>
                </ul>
            </div>
        </div>
        
        <!-- Danh mục chung -->
        <div class="border-bt" v-if="checkSchedule.length > 0">
            <div class="lkt_titleCatalog">
                <p>{{$t('new.title190')}}</p>
                <div class="setCourse">
                    <img @click="setCourse('/home/scheduleSetSelfMenu')" src="/static/images/settings.png" alt="settings" />
                </div>
            </div>
            <div class="listCatalog">
                <ul>
                    <li class="SchoolBusiness_menu_li lkt_hover" v-for="item in scheduleMenuOne" :key="item.id" :class="{isActive: activeItem.type == 4 && activeItem.tagID == item.id}" @click="changeItem({type : 4, tagID: item.id, language: $lang(), name: item.name})">
                        <p>&#9830; &nbsp;{{ item.name }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from "vuex";
    export default {
        data() {
            return {
                activeItem: {},
                isMyScheduleCourses: []
            };
        },
        computed: {
            // Kiem tra danh muc rieng
            checkSchedule () {
                if (this.myScheduleCourses.length > 0) {
                    this.isMyScheduleCourses = this.myScheduleCourses;
                    return this.isMyScheduleCourses;
                } else {
                    return this.isMyScheduleCourses
                }
            },
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                menuOne: (state) => state.schoolBussiness.menuOne,
                levelOne: (state) => state.schoolBussiness.levelOne,
                scheduleMenuOne: (state) => state.schoolBussiness.scheduleMenuOne,
                courseCompleted: (state) => state.schoolBussiness.courseCompleted,
                myScheduleCourses: (state) => state.schoolBussiness.myScheduleCourses,
            }),
        },
        created() {
            this.changeItem({type : 1, name: this.$t('new.title130')})
        },
        methods: {
            // Thay đổi item menu
            changeItem: function (item) {
                this.$api.post("/home/getLoginFlagUser", {
                    'loginName': window.sessionStorage.getItem('loginName'),
                    'companyId': window.sessionStorage.getItem('companyId')
                }).then(response => {
                    if (response.meta.success) {
                        this.activeItem = item;
                        this.$emit('changeItem', item);
                    }
                })
            },
            // Đến trang setting danh mục
            setCourse: function (url) {
                this.$router.push({
                    path: url,
                    query: {
                        fromPagetype: JSON.stringify(2),
                        isPcflag: JSON.stringify(0),
                    },
                });
            },
            ...mapActions("schoolBussiness", ["init", "initSchedule", "changeTagLvOne", "changeTagLvTwo", "switchCourses", "dislike", "like"]),
            ...mapMutations("schoolBussiness", ["setPage"]),
        },
    };
</script>
<style scoped>
    .school_business .lessons-done {
        height: 30px;
        justify-content: center;
        padding-right: unset;
        border-bottom: 1px solid #bdc3c7;
    }
    .listCatalog {
        padding-bottom: 10px;
        overflow: auto;
    }
    .listCatalog ul li {
        padding-left: 15px;
        font-size: 16px;
        cursor: pointer;
        height: 24px;
        display: flex;
        align-items: center;
    }
    .border-bt {
        border-bottom: 1px solid #bdc3c7;
    }
    .lkt_hover {
        cursor: pointer;
    }
    .lkt_hover:hover{
        background: #d7d7d7;
        border-radius: 5px;
    }
    .isActive {
        background: #0071c5 !important;
        border-radius: 5px;
        color: #fff !important;
    }
    .lkt_titleCatalog {
        height: 40px;
        font-size: 20px;
        font-weight: bold;
        color: #0071c5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        padding-left: 5px;
    }
    .setCourse {
        background: #eb2f06;
        padding: 3px;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        cursor: pointer;
    }
    .setCourse img {
        width: 19px;
    }
    .manage--left {
        box-shadow: 0px 5px 5px #dadae8;
        overflow: auto;
    }
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
    }
</style>



// WEBPACK FOOTER //
// src/components/schoolBusiness/pc/menu/catalog.vue